export default function variableAdder(content, data) {
  if (content !== null) {
    let cont = content;
    let replace = "{{([^}]+)}}";
    let re = new RegExp(replace, "g");
    cont = cont.replace(re, data);
    return cont;
  }
}
